import React from 'react';
import * as translator from "../../../utils/translator";
import { useParams } from 'react-router-dom';

type ProductCardProps = {
    cbd: number | null;
    thc: number | null;
    strain: string | null;
    imageSrc: string;
    titleView: string;
    price?: number;
    catalogPage: string | null;
    isOutOfStock?: boolean;
    badgeKey?: string; // Override the default out_of_stock/alternative badge translation key.
}

export const ProductCard: React.FC<ProductCardProps> = ({
    cbd,
    thc,
    strain,
    imageSrc,
    titleView,
    price,
    catalogPage,
    isOutOfStock = false,
    badgeKey
}) => {
    const cbdDisplay = cbd ? "CBD" + (Number(cbd) < 1 ? " < 1%" : `: ${cbd}%`) : null;
    const thcDisplay = thc ? `THC: ${thc}%` : null;
    // Only join with a separator when both values are present - avoids rendering a bare " | " for non-cannabis products.
    const thcAndcbdDisplay = thcDisplay && cbdDisplay ? `${thcDisplay} | ${cbdDisplay}` : (thcDisplay || cbdDisplay);
    const { country } = useParams();
    const badgeText = translator.translate(translator.getLanguageByCountry(country), "my_account", `MyOrders/details/alternative_offer_modal/${badgeKey ?? (isOutOfStock ? "out_of_stock" : "alternative")}`);
    return (
        <div
            id="alternative-offer-product-card"
            className="alternative-offer-product-card"
        >
            {/* positioned above the product image */}
            <div className={`product-availability-tag ${!isOutOfStock ? 'alternative' : ''}`}>
                {badgeText}
            </div>

            {/* img of the product */}
            <div className="product-img-container">
                <div className="product-image-wrapper">
                    <img
                        src={imageSrc}
                        alt="Medikament"
                        className={`product-img ${isOutOfStock ? 'product-img-out-of-stock' : ''}`}
                    />
                </div>
            </div>
            

            {/* product details */}
            <div className="cannabis-profile-details">
                {/* title and quantity */}
                <h3 className="product-title-and-quantity">{titleView}</h3>

                {/* cbd, thc and strain specifics - hidden entirely for non-cannabis products */}
                {thcAndcbdDisplay
                    ?
                    <span className="product-cannabis-profile-details-thc-and-cbd">{thcAndcbdDisplay}</span>
                    :
                    null
                }
                {strain
                    ?
                    <span className="product-cannabis-profile-details-strain">{translator.translate(translator.getLanguageByCountry(country), "my_account", "MyOrders/details/alternative_offer_modal/strain")}: {strain}</span>
                    :
                    null
                }

                {/* price */}
                {price !== undefined && <span className="product-price">{price.toFixed(2)} €</span>}

                {/* catalog link */}
                {catalogPage !== null ? <a
                    className="product-catalog-link mt-1"
                    rel="noreferrer"
                    href={catalogPage}
                    target="_blank"
                >
                    {translator.translate(translator.getLanguageByCountry(country), "my_account", "MyOrders/details/alternative_offer_modal/read_more")}
                </a> : null}
            </div>
        </div>
    );
}